<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedCategory !== null" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold {{ $t('category') | capitalize }}
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium.capitalize {{ selectedCategory }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold {{ $t('category') | capitalize }}
    
    .white
      .font-semibold.text-sm.px-4.pt-4.pb-2 {{ $t('filter_by') }} {{ $t('category') }}
      div
        .d-flex.text-sm.py-3.px-4
          yc-checkbox(v-model="medication" @change="selectCategory('medication', medication)")
          .ml-4 Medication
        v-divider.basic300
      div
        .d-flex.text-sm.py-3.px-4
          yc-checkbox(v-model="equipment" @change="selectCategory('equipment', equipment)")
          .ml-4 Equipment
        v-divider.basic300
      div.pb-2
        .d-flex.text-sm.py-3.px-4
          yc-checkbox(v-model="consumable" @change="selectCategory('consumable', consumable)")
          .ml-4 Consumable

    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="selectedCategory" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="TempSelectedCategory === null") {{ $t('apply') }}

</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: (() => {})
    },
    checkInitialValue: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showMenu: false,
    medication: false,
    equipment: false,
    consumable: false,
    TempSelectedCategory: null,
    selectedCategory: null,
  }),
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue) {
        if (this.filter.key) {
          this.selectedCategory = this.filter.value
          this.selectCategory(this.selectedCategory, true)
        }
      }
    },
    selectCategory (category, value) {
      if (!value) {
        this.TempSelectedCategory = null
        return
      }
      this.medication = false
      this.equipment = false
      this.consumable = false
      this[category] = true
      this.TempSelectedCategory = category
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.medication = false
      this.equipment = false
      this.consumable = false
      this.selectedCategory = null
      this.TempSelectedCategory = null
    },
    apply () {
      this.showMenu = false
      this.selectedCategory = this.TempSelectedCategory
      let filter = { key: 'category', value: this.selectedCategory }
      this.$emit('update:filter', filter)
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
</style>